import { GLOBAL_CONTEXT, USER_TYPE_COOKIE_NAME ,AD,EP} from "mmbclient/Common/CommonVariable";
import { useContext } from "react";
import DatePicker from "react-datepicker";
import CreditPickUpStatusController from "mmbclient/CreditPickUpRequest/CreditPickUpStatusController";
import CircularSpinner from "mmbclient/Components/CircularSpinner";
import { RenderPagination } from "mmbclient/Components/RenderPagination";
import { getCookie } from "mmbclient/Common/CommonFunctions";

export const CreditPickUpStatus = () => {

    const store = useContext(GLOBAL_CONTEXT);

    const { searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, betterLoggerFunction, handleSearch, exportToCSV, exportToExcel, selectAll, setSelectAll, selectedRows, setSelectedRows, toggleSelectAll, toggleRowSelection, handleMoveToBooking, showModal, modalType, modalMessage, setShowModal, handleClick} = CreditPickUpStatusController(store);
    
    return (
        <>
            {/* Bootstrap Modal */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden={!showModal}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {/* <div className={`modal-header alert-${modalType}`}> */}
                        <div className={`modal-header alert-${modalType} d-flex justify-content-between`}>
                            <h5 className="modal-title" id="modalLabel">Alert</h5>
                            <button type="button" className="close" onClick={() => setShowModal(false)} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {modalMessage}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner />}
                {/* Body Content */}
                <div className="container mt-4">
                    <div className="text-center">
                        <h1>PickUp Status</h1>
                    </div>
                    <hr class="my-4" />
                    <div className="row mb-4">
                    {
                        (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME === EP))?
                                                <div className="col-md-3">
                            <label className="form-label">Client</label>
                            <select
                                className="form-select"
                                value={client}
                                onChange={(e) => setClient(e.target.value)}
                            >
                                {clientOption.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        :null
                    }

                        <div className="col-md-2">
                            <label className="form-label">Start Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">End Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="col-12 d-flex flex-wrap gap-2 justify-content-start mt-2">
                            <button className="btn btn-primary px-4" style={{ height: "40px" }} onClick={() => {
                                /* search function */
                                setCurrentPage(1); // Reset to first page on search                                        
                                setSelectAll(false);
                                setSelectedRows([]);
                                handleSearch();
                            }}>
                                Search
                            </button>

                            {
                                 (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME === EP))?
                                <button className="btn btn-success px-4" style={{ height: "40px" }} disabled={selectedRows.length === 0}
                                onClick={handleMoveToBooking}
                            >
                                Move to Booking
                            </button>
                            : null
                            }
                            
                        </div>


                        {/* <div className="col-md-1 d-flex align-items-end">
                            <button className="btn btn-primary mt-2"
                                onClick={
                                    () => {
                                        setCurrentPage(1); // Reset to first page on search                                        
                                        setSelectAll(false);
                                        setSelectedRows([]);
                                        handleSearch();
                                    }
                                }>
                                Search
                            </button>
                        </div>
                        <div className="col-md-2 d-flex align-items-end">
                            <button className="btn btn-success mt-2"
                                disabled={selectedRows.length === 0}>
                                Move to Booking
                            </button>
                        </div> */}
                    </div>

                    {/* Export Buttons */}
                    <hr class="my-4" />
                    <div className="mb-3 d-flex align-items-center">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="form-control me-2 flex-grow-1"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1); // Reset to first page on search
                            }}
                        />
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Export
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <button className="dropdown-item" onClick={exportToCSV}>
                                        Export to CSV
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item" onClick={exportToExcel}>
                                        Export to Excel
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Data Table */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>SNo</th>
                                    {
                                         (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME === EP))?
                                         <th className="text-center">
                                        <input type="checkbox" className="form-check-input" style={{ transform: "scale(1.5)" }} checked={selectAll} onChange={toggleSelectAll} />
                                    </th>
                                     : null
                                    }
                                    
                                    <th style={{ whiteSpace: "nowrap" }}>Awb No.</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Date</th>
                                    <th>Client</th>
                                    <th>Network</th>
                                    <th>Service</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Origin Pincode</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Origin City</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Destination Pincode</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Destination City</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Destination Country</th>
                                    <th>Do/In</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Receiver Phone</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Receiver Name</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Receiver Address</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Docket Report</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                             {
                                         (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME === EP))?
                                         <td className="text-center">
                                                <input type="checkbox" className="form-check-input" style={{ transform: "scale(1.5)" }} checked={selectedRows.includes(item.awb_no)} onChange={() => toggleRowSelection(item.awb_no)} />
                                                </td>
                                            : null
                                            }
                                            

                                            <td style={{ whiteSpace: "nowrap" }}>{item.awb_no}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.request_date}</td>
                                            <td>{item.client_code}</td>
                                            <td>{item.network_code}</td>
                                            <td>{item.service_group_code}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.origin_pincode}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.origin_city}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.destination_pincode}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.destination_city}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.destination_county}</td>
                                            <td>{item.do_in}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.consignee_phone}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.consignee_name}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{item.consignee_address}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{
                                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-2">
                                        <a 
                                            href="javascript:void(0)" 
                                            onClick={()=>handleClick(item.awb_no,item.client_code)} 
                                            className="mt-3 d-block" 
                                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                print
                                        </a>
                                    </div>
                                </div>}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="16" className="text-center">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center">
                                <RenderPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
                            </ul>
                        </nav>
                    </div>
                </div>

                {/* Footer */}
                {/* <footer className="bg-light text-center py-3">
                <div className="container">
                    <span>© 2024 My Application. All Rights Reserved.</span>
                </div>
                </footer> */}
            </div >
        </>
    );

}